<template>
  <nav class="navbar" :class="'navbar--' + theme">
    <div class="nav-inner">
      <div class="logo" @click="$router.push('/')">
        <img v-if="theme === 'light'" :src="logoGreen" alt="iBuzzPen" />
        <img v-else :src="logoLight" alt="iBuzzPen" />
      </div>
      <ul class="nav-tabs">
        <li
          v-for="tab in tabs"
          :key="tab.name"
          :class="{ active: activeTab === tab.name }"
          @click="handleTabClick(tab)"
        >
          {{ tab.label }}
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AppNavbar',
  props: {
    activeTab: {
      type: String,
      default: 'Home'
    },
    theme: {
      type: String,
      default: 'dark', // 'dark' | 'light'
      validator: v => ['dark', 'light'].includes(v)
    }
  },
  data() {
    return {
      logoLight: require('@/assets/logo.png'),
      logoGreen: require('@/assets/logo1.png'),
      tabs: [
        { name: 'Home', label: 'Home', path: '/' },
        { name: 'iBuzzPen', label: 'iBuzzPen', path: '/ibuzzpen' },
        { name: 'OurStory', label: 'Our Story', path: '/our-story' },
        { name: 'Contact', label: 'Contact', path: '/contact' }
      ]
    }
  },
  methods: {
    handleTabClick(tab) {
      this.$emit('update:activeTab', tab.name)
      if (tab.path && this.$route.path !== tab.path) {
        this.$router.push(tab.path).catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// Layout
$container-max: 1760px;

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  padding: 20px clamp(24px, 10.94vw, 210px);

  .nav-inner {
    max-width: $container-max;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .logo {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;

    img {
      height: 36px;
      width: auto;
    }
  }

  .nav-tabs {
    display: flex;
    gap: 36px;
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      font-size: 15px;
      font-weight: 500;
      cursor: pointer;
      padding: 6px 2px;
      position: relative;
      transition: color 0.3s;
      white-space: nowrap;
    }
  }
}

// Dark theme (home page)
.navbar--dark {
  .nav-tabs li {
    color: rgba(255, 255, 255, 0.75);

    &:hover { color: #fff; }

    &.active {
      color: #fff;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 20px;
        height: 2px;
        background: #fff;
        border-radius: 1px;
      }
    }
  }
}

// Light theme (contact page)
.navbar--light {
  background: #fff;

  .nav-tabs li {
    color: #333;

    &:hover { color: #000; }

    &.active {
      color: #000;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 20px;
        height: 2px;
        background: #000;
        border-radius: 1px;
      }
    }
  }
}

// ========== Responsive: Tablet ==========
@media (max-width: 1024px) {
  .navbar {
    .logo img { height: 30px; }
    .nav-tabs {
      gap: 24px;
      li { font-size: 14px; }
    }
  }
}

// ========== Responsive: Mobile ==========
@media (max-width: 768px) {
  .navbar {
    padding: 14px clamp(16px, 5vw, 24px);
    .nav-inner { justify-content: flex-end; }
    .logo img { height: 26px; }
    .nav-tabs {
      gap: 16px;
      li {
        font-size: 13px;
        padding: 4px 0;
        &.active::after { width: 16px; }
      }
    }
  }
}

@media (max-width: 480px) {
  .navbar {
    .nav-tabs {
      gap: 12px;
      li { font-size: 12px; }
    }
  }
}
</style>
